import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import DashboardMenu from "./DashboardMenu";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardMenuEach from "./DashboardMenuEach";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import LeftMenu from "./LeftMenu";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { TextField } from "@mui/material";
import Alert from "@mui/material/Alert";
import { addDoc, collection, db } from "../../firebase";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  body: { backgroundColor: "white", minHeight: "500px", padding: "50px" },
  title: { fontSize: "30px" },
});

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [progress, setProgress] = useState(true);

  const [subject, setSubject] = React.useState("My Order");

  const [toSend, setToSend] = useState({
    from_name: "",
    phone: "",
    message: "",
    reply_to: "",
  });
  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    // console.log(stripUserId);
    setTimeout(() => {
      setProgress(false);
    }, 500);
  }, []);

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="support" />
      <Grid md={9} sm={12} className={classes.body}>
        <Box className={classes.title}>
          <Box sx={{ fontSize: "16px", fontWeight: "bold" }}>
            <Fade delay={300}>{t("Request a support")}</Fade>
          </Box>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography sx={{ color: "#616161", pb: 3, lineHeight: "1.9em" }}>
            <Fade delay={300}>
              {t(
                "What would you like help with today? Please connect with us when needed. We will get back to you as soon as possible. Thank you!"
              )}
            </Fade>
          </Typography>

          {msg ? <Alert>{msg}</Alert> : null}

          <div>
            <FormControl sx={{ width: "400px", my: 2 }}>
              <InputLabel id="demo-simple-select-label">
                {t("Subject")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={subject}
                label="Select a subject"
                onChange={(e) => setSubject(e.target.value)}
              >
                <MenuItem value={"My Order"}>{t("Order")}</MenuItem>
                <MenuItem value={"Return"}>{t("Return")}</MenuItem>
                <MenuItem value={"Technical Problem"}>
                  {t("Technical Problem")}
                </MenuItem>
                <MenuItem value={"Product"}>{t("Product")}</MenuItem>
                <MenuItem value={"Technology"}>{t("Technology")}</MenuItem>
                <MenuItem value={"Other"}>{t("Other")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <TextField
              className={classes.inputs}
              type="text"
              name="from_name"
              variant="filled"
              label={t("your_name")}
              value={toSend.from_name}
              onChange={handleChange}
              sx={{ my: 1 }}
            />
            <TextField
              type="text"
              name="phone"
              label={t("Phone*")}
              variant="filled"
              value={toSend.phone}
              onChange={handleChange}
              sx={{ my: 1 }}
            />

            <TextField
              type="text"
              name="reply_to"
              variant="filled"
              label={t("Your email*")}
              value={toSend.reply_to}
              onChange={handleChange}
              sx={{ my: 1 }}
            />
            <TextField
              type="text"
              name="message"
              variant="filled"
              label={t("Your message*")}
              value={toSend.message}
              onChange={handleChange}
              className={classes.inputs}
              multiline
              rows={10}
              rowsMax={50}
              sx={{ my: 1, mb: 3 }}
            />
          </Box>

          <button
            type="submit"
            className="custom_btn"
            style={{ width: "250px" }}
          >
            {loading ? "... Sending" : t("Contact Us")}
          </button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
